/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Connection/view.blocks to change it.
import * as fromFlow from 'Simple/Flow'
import Offline from './Offline/index'
import Online from './Online/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Connection({
  children,
  viewPath = "/App/Form/Connection"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'Online'
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'Online'}>
<Online
  viewPath={`${viewPath}/Online`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Offline'}>
<Offline
  viewPath={`${viewPath}/Offline`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}